export class States {
	private static stateMap: Map<string, any> = new Map<string, any>();
	private static abbrevMap: Map<string, any> = new Map<string, any>();
	private static _states: any[] = [
		{ id: 'AL', name: 'Alabama', bbox: [ { lat: -88.473227, lng: 30.223334 }, { lat: 35.008028, lng: -84.88908 }] },
		{ id: 'AK', name: 'Alaska', bbox: [ { lat: 51.214183, lng: -179.148909 }, { lat: 71.365162, lng: -179.77847 } ] },
		{ id: 'AZ', name: 'Arizona', bbox: [ { lat: 31.332177, lng: -114.81651 }, { lat: 37.00426, lng: -109.045223 } ] },
		{ id: 'AR', name: 'Arkansas', bbox: [ { lat: 33.004106, lng: -94.617919 }, { lat: 36.4996, lng: -89.644395 } ] },
		{ id: 'CA', name: 'California', bbox: [ { lat: 32.534156, lng: -124.409591 }, { lat: 42.009518, lng: -114.131211 } ] },
		{ id: 'CO', name: 'Colorado', bbox: [ { lat: 36.992426, lng: -109.060253 }, { lat: 41.003444, lng: -102.041524 } ] },
		{ id: 'CT', name: 'Connecticut', bbox: [ { lat: 40.980144, lng: -73.727775 }, { lat: 42.050587, lng: -71.786994 } ] },
		{ id: 'DC', name: 'Washington D.C.', bbox: [ { lat: 38.791645, lng: -77.119759 }, { lat: 38.99511, lng: -76.909395 } ] },
		{ id: 'DE', name: 'Delaware', bbox: [ { lat: 38.451013, lng: -75.788658 }, { lat: 39.839007, lng: -75.048939 } ] },
		{ id: 'FL', name: 'Florida', bbox: [ { lat: 24.523096, lng: -87.634938 }, { lat: 31.000888, lng: -80.031362 } ] },
		{ id: 'GA', name: 'Georgia', bbox: [ { lat: 30.357851, lng: -85.605165 }, { lat: 35.000659, lng: -80.839729 } ] },
		{ id: 'HI', name: 'Hawaii', bbox: [ { lat: 18.910361, lng: -178.334698 }, { lat: 28.402123, lng: -154.806773 } ] },
		{ id: 'ID', name: 'Idaho', bbox: [ { lat: 41.988057, lng: -117.243027 }, { lat: 49.001146, lng: -111.043564 } ] },
		{ id: 'IL', name: 'Illinois', bbox: [ { lat: 36.970298, lng: -91.513079 }, { lat: 42.508481, lng: -87.494756 } ] },
		{ id: 'IN', name: 'Indiana', bbox: [ { lat: 37.771742, lng: -88.09776 }, { lat: 41.760592, lng: -84.784579 } ] },
		{ id: 'IA', name: 'Iowa', bbox: [ { lat: 40.375501, lng: -96.639704 }, { lat: 43.501196, lng: -90.140061 } ] },
		{ id: 'KS', name: 'Kansas', bbox: [ { lat: 36.993016, lng: -102.051744 }, { lat: 40.003162, lng: -94.588413 } ] },
		{ id: 'KY', name: 'Kentucky', bbox: [ { lat: 36.497129, lng: -89.571509 }, { lat: 39.147458, lng: -81.964971 } ] },
		{ id: 'LA', name: 'Louisiana', bbox: [ { lat: 28.928609, lng: -94.043147 }, { lat: 33.019457, lng: -88.817017 } ] },
		{ id: 'ME', name: 'Maine', bbox: [ { lat: 42.977764, lng: -71.083924 }, { lat: 47.459686, lng: -66.949895 } ] },
		{ id: 'MD', name: 'Maryland', bbox: [ { lat: 37.911717, lng: -79.487651 }, { lat: 39.723043, lng: -75.048939 } ] },
		{ id: 'MA', name: 'Massachusetts', bbox: [ { lat: 41.237964, lng: -73.508142 }, { lat: 42.886589, lng: -69.928393 } ] },
		{ id: 'MI', name: 'Michigan', bbox: [ { lat: 41.696118, lng: -90.418136 }, { lat: 48.2388, lng: -82.413474 } ] },
		{ id: 'MN', name: 'Minnesota', bbox: [ { lat: 43.499356, lng: -97.239209 }, { lat: 49.384358, lng: -89.491739 } ] },
		{ id: 'MS', name: 'Mississippi', bbox: [ { lat: 30.173943, lng: -91.655009 }, { lat: 34.996052, lng: -88.097888 } ] },
		{ id: 'MO', name: 'Missouri', bbox: [ { lat: 35.995683, lng: -95.774704 }, { lat: 40.61364, lng: -89.098843 } ] },
		{ id: 'MT', name: 'Montana', bbox: [ { lat: 44.358221, lng: -116.050003 }, { lat: 49.00139, lng: -104.039138 } ] },
		{ id: 'NE', name: 'Nebraska', bbox: [ { lat: 39.999998, lng: -104.053514 }, { lat: 43.001708, lng: -95.30829 } ] },
		{ id: 'NV', name: 'Nevada', bbox: [ { lat: 35.001857, lng: -120.005746 }, { lat: 42.002207, lng: -114.039648 } ] },
		{ id: 'NH', name: 'New Hampshire', bbox: [ { lat: 42.69699, lng: -72.557247 }, { lat: 45.305476, lng: -70.610621 } ] },
		{ id: 'NJ', name: 'New Jersey', bbox: [ { lat: 38.928519, lng: -75.559614 }, { lat: 41.357423, lng: -73.893979 } ] },
		{ id: 'NM', name: 'New Mexico', bbox: [ { lat: 31.332301, lng: -109.050173 }, { lat: 37.000232, lng: -103.001964 } ] },
		{ id: 'NY', name: 'New York', bbox: [ { lat: 40.496103, lng: -79.762152 }, { lat: 45.01585, lng: -71.856214 } ] },
		{ id: 'NC', name: 'North Carolina', bbox: [ { lat: 33.842316, lng: -84.321869 }, { lat: 36.588117, lng: -75.460621 } ] },
		{ id: 'ND', name: 'North Dakota', bbox: [ { lat: 45.935054, lng: -104.0489 }, { lat: 49.000574, lng: -96.554507 } ] },
		{ id: 'OH', name: 'Ohio', bbox: [ { lat: 38.403202, lng: -84.820159 }, { lat: 41.977523, lng: -80.518693 } ] },
		{ id: 'OK', name: 'Oklahoma', bbox: [ { lat: 33.615833, lng: -103.002565 }, { lat: 37.002206, lng: -94.430662 } ] },
		{ id: 'OR', name: 'Oregon', bbox: [ { lat: 41.991794, lng: -124.566244 }, { lat: 46.292035, lng: -116.463504 } ] },
		{ id: 'PA', name: 'Pennsylvania', bbox: [ { lat: 39.7198, lng: -80.519891 }, { lat: 42.26986, lng: -74.689516 } ] },
		{ id: 'RI', name: 'Rhode Island', bbox: [ { lat: 41.146339, lng: -71.862772 }, { lat: 42.018798, lng: -71.12057 } ] },
		{ id: 'SC', name: 'South Carolina', bbox: [ { lat: 32.0346, lng: -83.35391 }, { lat: 35.215402, lng: -78.54203 } ] },
		{ id: 'SD', name: 'South Dakota', bbox: [ { lat: 42.479635, lng: -104.057698 }, { lat: 45.94545, lng: -96.436589 } ] },
		{ id: 'TN', name: 'Tennessee', bbox: [ { lat: 34.982972, lng: -90.310298 }, { lat: 36.678118, lng: -81.6469 } ] },
		{ id: 'TX', name: 'Texas', bbox: [ { lat: 25.837377, lng: -106.645646 }, { lat: 36.500704, lng: -93.508292 } ] },
		{ id: 'UT', name: 'Utah', bbox: [ { lat: 36.997968, lng: -114.052962 }, { lat: 42.001567, lng: -109.041058 } ] },
		{ id: 'VT', name: 'Vermont', bbox: [ { lat: 42.726853, lng: -73.43774 }, { lat: 45.016659, lng: -71.464555 } ] },
		{ id: 'VA', name: 'Virginia' , bbox: [ { lat: 36.540738, lng: -83.675395 }, { lat: 39.466012, lng: -75.242266 } ] },
		{ id: 'WA', name: 'Washington', bbox: [ { lat: 45.543541, lng: -124.763068 }, { lat: 49.002494, lng: -116.915989 } ] },
		{ id: 'WV', name: 'West Virginia', bbox: [ { lat: 37.201483, lng: -82.644739 }, { lat: 40.638801, lng: -77.719519 } ] },
		{ id: 'WI', name: 'Wisconsin', bbox: [ { lat: 42.491983, lng: -92.888114 }, { lat: 47.080621, lng: -86.805415 } ] },
		{ id: 'WY', name: 'Wyoming', bbox: [ { lat: 40.994746, lng: -111.056888 }, { lat: 45.005904, lng: -104.05216 } ] },
	];

	static initialize(): void {
		States._states.forEach(
			(state: any) => {
				States.stateMap.set(state.name, state);
				States.abbrevMap.set(state.id, state);
			}
		);
	}

	static translateToAbbreviation(name: string): string {
		const state: any = States.stateMap.get(name);
		return state.name;
	}

	static getFullStateName(id: string): string {
		const state: any = States.abbrevMap.get(id);
		return state?.name || '';
	}

	static get states(): any[] {
		return States._states;
	}

	static getStateByCode(code: string) : any {
		return States.abbrevMap.get(code);
	}

	static getStateByName(name: string) : any {
		return States.stateMap.get(name);
	}
}
States.initialize();

